import { useRef } from 'react';
import { getMostViewedWebContent } from '../../../datafetchers/HomePage';
import {
  createRippleEffectRelative,
  getContentType,
} from '../../../Utils/helper';
import { ViewAllButtonVerm } from '../../StoreCategoryPage/ViewAllProducts/styled';
import { fireClickedCTAEvent } from '../../../Utils/useFirebase';

export default function LoadMore(props) {
  const { contentArray, showLoader, setShowLoadMore, heading, mutate, stage } =
    props;
  const limit = 6;
  const skipRef = useRef(1);
  const responseRef = useRef();
  const fetchMoreArticlesVideosHandler = async () => {
    showLoader(true);
    const params = {
      skip: skipRef?.current * limit,
      limit: limit,
      webViewedItemStage: stage,
    };
    getMostViewedWebContent(params).then((response) => {
      const oldData = contentArray;
      responseRef.current = response?.data;
      const finalData = [...oldData, ...responseRef.current];
      skipRef.current = skipRef?.current + 1;
      mutate(finalData, false);
      showLoader(false);
      if (responseRef?.current?.length < limit) {
        setShowLoadMore(false);
      }
    });
  };
  return (
    <ViewAllButtonVerm
      id="loadMoreArticle"
      width="400px"
      onClick={(e) => {
        createRippleEffectRelative(
          e,
          document.getElementById('loadMoreArticle'),
          ' black',
        );
        fireClickedCTAEvent(heading, 'Load More', getContentType());
        setTimeout(() => {
          fetchMoreArticlesVideosHandler();
        }, 400);
      }}
    >
      LOAD MORE ARTICLES
    </ViewAllButtonVerm>
  );
}
